export default __webpack_public_path__ + "static/media/Site_Viewer_Role.2ff324dd.svg";